import CheckPermission from "./CheckPermission";

export const smsCampaignPermissions = {
  list: ["sms_campaign_list"],
  view: ["sms_campaign_get_details"],
  create: ["sms_campaign_create", "sms_campaign_lines"],
  edit: ["sms_campaign_edit", "sms_campaign_get_details"],
};

export const canAccessSmsCampaign = (action, permissions) =>
  smsCampaignPermissions[action].every((permission) =>
    CheckPermission(permission, permissions)
  );
